<template>
  <div
    class="subheader min-h-lg-175px pt-5 pb-7"
    v-bind:class="subheaderClasses"
    id="kt_subheader"
  >
    <div
      class="d-flex align-items-center justify-content-center flex-wrap flex-sm-nowrap"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="d-flex align-items-center flex-wrap justify-content-center">
        <!--begin::Heading-->
        <div class="d-flex flex-column">

          <!--begin::Title-->
          <h2
            class="text-white font-weight-bold my-2 mr-5"
            v-if="business"
            style="font-size: 23px; text-align: center;"
          >
            Bienvenido a {{ business.name }}.
          </h2>
          <p
            class="text-white font-weight-bold my-2 mr-5"
            style="font-size: 14px; text-align: center;"
          >
            Te damos la bienvenida a nuestro catálogo online de productos Naos. <br/>
            Solicítanos aquí tu pedido y lo tendremos listo para recoger en nuestro punto de venta o te lo enviamos a casa (consulta condiciones)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    shopTitle: String
  },
  computed: {
    ...mapGetters(["layoutConfig", "business"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    },

    businessLogo() {
      if (this.business) {
        return this.business.imageId;
      } else {
        return null;
      }
    }

  }
};
</script>
